import { lightTheme as coreLight } from '@gojitsu/web-ui-core';
import { createTheme } from '@mui/material/styles';

export const lightTheme = createTheme({
  ...coreLight,
  typography: {
    ...coreLight.typography,
    button: { textTransform: 'inherit' },
  },
});
